// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"5093aa1b","453":"55b25364","486":"dee84fed","907":"175b697e"}[chunkId] + ".chunk.js";
};